import { createContext } from "react";

const MunicipalityDataContext = createContext();//this context is for determine witch municipality to use 

export default MunicipalityDataContext;